var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('a',{attrs:{"slot":"activator","href":"/honey/"},slot:"activator"},[_c('img',{staticClass:"page404",attrs:{"src":"/images/404_page.png","alt":"PageNotFound404"}})]),_c('span',[_vm._v("Go Back")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }